import React from 'react';
import { motion } from 'framer-motion';
import { Car, ShieldCheck, Activity } from 'lucide-react';
interface HeroSectionProps {
  onNavigate: (page: string) => void;
}
export function HeroSection({
  onNavigate
}: HeroSectionProps) {
  return <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden bg-earia-bg" data-id="element-175">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#1e2a4a 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-176"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-177">
        <div className="flex flex-col items-center text-center mb-12" data-id="element-178">
          <motion.h1 initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-earia-text-heading mb-6 tracking-tight" data-id="element-179">
            Importá tu vehículo de forma
            <br data-id="element-180" />
            <span className="relative inline-block" data-id="element-181">
              <span className="relative z-10" data-id="element-182">inteligente, no a ciegas.</span>
              <span className="absolute bottom-2 left-0 right-0 h-3 bg-earia-accent/30 -z-10 transform -rotate-1" data-id="element-183"></span>
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-lg text-earia-text-body max-w-2xl mb-10" data-id="element-184">
            Como tu broker personal, cuidamos tu inversión, analizamos,
            calculamos y gestionamos tu importación desde EE.UU. a El Salvador
            con transparencia total y trato directo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="flex flex-col sm:flex-row items-center gap-4" data-id="element-185">
            <button onClick={() => onNavigate('car-finder')} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg text-lg transition-all shadow-lg shadow-blue-600/20" data-id="element-186">
              Tu Carro Ideal
            </button>
            <a href="#cta" className="bg-earia-accent hover:bg-earia-accent-hover text-earia-text-heading font-bold py-3 px-8 rounded-lg text-lg transition-all shadow-lg shadow-earia-accent/20" data-id="element-187">
              Obtén tu Cotización
            </a>
          </motion.div>
        </div>

        {/* Hero Card - The "Product" Interface */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="relative max-w-3xl mx-auto" data-id="element-188">
          {/* Floating Animation Wrapper */}
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} className="bg-earia-card rounded-xl border border-earia-border shadow-xl overflow-hidden" data-id="element-189">
            {/* Card Header */}
            <div className="bg-earia-bg-alt px-6 py-4 border-b border-earia-border flex justify-between items-center" data-id="element-190">
              <div className="flex items-center gap-2" data-id="element-191">
                <Activity className="w-4 h-4 text-earia-accent" data-id="element-192" />
                <span className="text-sm font-mono text-earia-text-body" data-id="element-193">
                  ANÁLISIS
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-194"></div>
            </div>

            {/* Card Body */}
            <div className="p-6 md:p-8 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-195">
              {/* Left: Vehicle Info */}
              <div className="space-y-6" data-id="element-196">
                <div className="flex items-start justify-between" data-id="element-197">
                  <div data-id="element-198">
                    <h3 className="text-xl font-bold text-earia-text-heading" data-id="element-199">
                      2021 Nissan Sentra SR
                    </h3>
                    <p className="text-sm text-earia-text-body" data-id="element-200">
                      VIN: *****************
                    </p>
                  </div>
                  <div className="bg-earia-bg-alt p-2 rounded-lg" data-id="element-201">
                    <Car className="w-6 h-6 text-earia-text-body" data-id="element-202" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-203">
                  <div className="flex justify-between text-sm" data-id="element-204">
                    <span className="text-earia-text-body" data-id="element-205">
                      Puntaje de Daños
                    </span>
                    <span className="text-earia-text-heading font-mono" data-id="element-206">
                      72/100
                    </span>
                  </div>
                  <div className="h-2 bg-earia-bg-alt rounded-full overflow-hidden" data-id="element-207">
                    <div className="h-full bg-earia-accent w-[72%] rounded-full" data-id="element-208"></div>
                  </div>
                  <ul className="text-xs text-earia-text-body text-right space-y-1 list-none" data-id="element-209">
                    <li data-id="element-210">- Daños menores en parachoques Frontal</li>
                    <li data-id="element-211">- Reemplazar Faro Derecho</li>
                    <li data-id="element-212">- Daño menor en el Fender Derecho</li>
                  </ul>
                </div>

                <div className="flex items-center gap-3 bg-earia-success/10 border border-earia-success/20 p-3 rounded-lg" data-id="element-213">
                  <ShieldCheck className="w-5 h-5 text-earia-success" data-id="element-214" />
                  <div data-id="element-215">
                    <p className="text-sm font-bold text-earia-success" data-id="element-216">
                      Bajo Riesgo
                    </p>
                    <p className="text-xs text-earia-success/80" data-id="element-217">
                      Documentación verificada
                    </p>
                  </div>
                </div>
              </div>

              {/* Right: Cost Estimate */}
              <div className="bg-earia-bg-alt/50 rounded-lg p-5 border border-earia-border flex flex-col justify-between" data-id="element-218">
                <div data-id="element-219">
                  <p className="text-sm text-earia-text-body mb-4" data-id="element-220">
                    Estimado Total (Puesto en SV)
                  </p>
                  <div className="space-y-3" data-id="element-221">
                    <div className="flex justify-between text-sm" data-id="element-222">
                      <span className="text-earia-text-body" data-id="element-223">
                        Subasta (Aprox)
                      </span>
                      <span className="text-earia-text-heading font-mono" data-id="element-224">
                        $4,220
                      </span>
                    </div>
                    <div className="flex justify-between text-sm" data-id="element-225">
                      <span className="text-earia-text-body" data-id="element-226">Grúa + Flete</span>
                      <span className="text-earia-text-heading font-mono" data-id="element-227">
                        $1060
                      </span>
                    </div>
                    <div className="flex justify-between text-sm" data-id="element-228">
                      <span className="text-earia-text-body" data-id="element-229">
                        Impuestos + Trámites
                      </span>
                      <span className="text-earia-text-heading font-mono" data-id="element-230">
                        $2,711
                      </span>
                    </div>
                    <div className="flex justify-between text-sm" data-id="element-231">
                      <span className="text-[#E6AC00]" data-id="element-232">Servicio</span>
                      <span className="text-earia-text-heading font-mono" data-id="element-233">
                        $250 + IVA
                      </span>
                    </div>
                    <div className="flex justify-between text-sm" data-id="element-234">
                      <span className="text-earia-text-body" data-id="element-235">
                        Reparación (Estimado)
                      </span>
                      <span className="text-earia-text-heading font-mono" data-id="element-236">
                        $1,317
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-6 pt-4 border-t border-earia-border" data-id="element-237">
                  <div className="flex justify-between items-end" data-id="element-238">
                    <span className="text-sm font-medium text-earia-accent-hover" data-id="element-239">
                      TOTAL ESTIMADO
                    </span>
                    <span className="text-2xl font-bold text-earia-text-heading font-mono" data-id="element-240">
                      $9,590.5
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Decorative Elements behind card */}
          <div className="absolute -top-10 -right-10 w-32 h-32 bg-earia-accent/10 rounded-full blur-3xl" data-id="element-241"></div>
          <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-blue-500/10 rounded-full blur-3xl" data-id="element-242"></div>
        </motion.div>
      </div>
    </section>;
}